import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";
import { brandName, isIntlSite } from "@/lib/market";

type Tone = "light" | "dark";

// The ravoq (arch) mark with the gold sparkle inside it.
export function ArchMark({ tone = "light", className = "tk-logo__mark" }: { tone?: Tone; className?: string }) {
  return (
    <svg className={className} viewBox="0 0 26 30" fill="none" aria-hidden="true">
      <path
        d="M3 29 V13 A10 10 0 0 1 23 13 V29"
        stroke={tone === "dark" ? "var(--tk-gold)" : "var(--tk-anor)"}
        strokeWidth={1.6}
      />
      <path
        d="M13 11 C13.5 15 15 16.5 19 17 C15 17.5 13.5 19 13 23 C12.5 19 11 17.5 7 17 C11 16.5 12.5 15 13 11 Z"
        fill={tone === "dark" ? "var(--tk-footer-ink)" : "var(--tk-gold)"}
      />
    </svg>
  );
}

export function TkLogo({
  tone = "light",
  to = "/",
  onClick,
}: {
  tone?: Tone;
  to?: string;
  onClick?: () => void;
}) {
  const t = useT();
  const intl = isIntlSite();
  return (
    <Link
      to={to}
      onClick={onClick}
      className={tone === "dark" ? "tk-logo tk-logo--dark" : "tk-logo"}
      aria-label={`${brandName()} — ${t("tk.nav.home_aria")}`}
    >
      {intl && tone === "light" ? (
        <img className="tk-logo__img" src="/brand/utopian-logo.webp" alt="Utopian Invitations" />
      ) : intl ? (
        <span className="tk-logo__word">Utopian Invitations</span>
      ) : (
        <>
          <ArchMark tone={tone} />
          <span className="tk-logo__word">
            taklifla<span className="tk-logo__tld">.uz</span>
          </span>
        </>
      )}
    </Link>
  );
}
